import { useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
interface Props {
  className?: any;
  isOpen?: boolean;
  children: any;
  trigger?: any;
  toggleModal?: any;
  hideClose?: boolean;
}
export default function CustomDialog({
  isOpen,
  className,
  children,
  trigger,
  toggleModal,
  hideClose
}: Props) {
  const dialogRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!toggleModal) return;
    const handleOutsideClick = (event: MouseEvent) => {
      if (isOpen && dialogRef.current && !dialogRef.current.contains(event.target as Node) && !(event.target as HTMLElement).classList.contains('nocollapsemodal')) {
        toggleModal();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, toggleModal]);
  return <Dialog open={isOpen} data-sentry-element="Dialog" data-sentry-component="CustomDialog" data-sentry-source-file="customDialog.tsx">
      {trigger && <DialogTrigger asChild>
          <div role='button' aria-label='Open Dialog'>
            {trigger}
          </div>
        </DialogTrigger>}

      <DialogContent ref={dialogRef} hideClose={hideClose} aria-labelledby='dialog-title' aria-describedby='dialog-description' toggleModal={toggleModal} onClick={e => e.stopPropagation()} // Prevent clicks inside the modal from propagating
    className={`dialog-content max-h-[755px] max-w-[834px] w-full h-full overflow-hidden p-4 ${className ? className : ''} rounded-[20px]`} data-sentry-element="DialogContent" data-sentry-source-file="customDialog.tsx">
        <div className='w-full justify-center'>{children}</div>
      </DialogContent>
    </Dialog>;
}